// Mock data for Owed — grants finder + unclaimed money recovery
// All data is illustrative for a frontend prototype.

export const CATEGORIES = [
    { id: "business", label: "Small Business", icon: "Briefcase" },
    { id: "education", label: "Education", icon: "GraduationCap" },
    { id: "housing", label: "Housing", icon: "Home" },
    { id: "healthcare", label: "Healthcare", icon: "Heart" },
    { id: "agriculture", label: "Agriculture", icon: "Sprout" },
    { id: "arts", label: "Arts & Culture", icon: "Palette" },
    { id: "research", label: "Research", icon: "Microscope" },
    { id: "nonprofit", label: "Nonprofit", icon: "HeartHandshake" },
    { id: "veteran", label: "Veteran", icon: "Shield" },
    { id: "reentry", label: "Reentry & Second Chance", icon: "KeyRound" },
    { id: "community", label: "Community", icon: "Users" },
];

export const GRANTS = [
    {
        id: "g-tx-trla-legal-aid",
        title: "Texas RioGrande Legal Aid — Free Attorney (Deed Fraud / Quiet Title / Probate)",
        org: "Texas RioGrande Legal Aid (TRLA)",
        orgShort: "TRLA",
        amount: 3500,
        deadline: "Rolling",
        category: "reentry",
        difficulty: "Easy",
        matchScore: 98,
        description: "Free legal representation for title disputes, deed fraud (forged deeds), quiet-title suits, probate/inheritance issues, and estate claims. Covers Aransas County. Reentry cases are priority queue. Average case value if you hired privately: $2,500–$6,000 in attorney fees saved.",
        eligibility: ["Household income under 200% federal poverty line", "Texas resident in TRLA service area (includes Aransas County)", "Civil legal matter (not criminal)", "Call intake line: 1-888-988-9996"],
        tags: ["reentry", "texas", "legal-aid", "deed-fraud", "free-attorney", "local"],
        portal_url: "https://www.trla.org/apply-for-help",
        color: "primary",
    },
    {
        id: "g-tx-estate-claim-lawson",
        title: "Probate Claim Against Estate of Robert Lawson (Stolen Tax Money)",
        org: "Texas Estates Code §355.101 — File in Aransas County Probate Court",
        orgShort: "PROBATE",
        amount: 6000,
        deadline: "2027-05-31",
        category: "reentry",
        difficulty: "Medium",
        matchScore: 92,
        description: "Statutory deadline: 4 years from date of death (Robert Lawson died 2023 → deadline approximately May 2027). Claim covers property tax money diverted during 2019–2022 while you were incarcerated + any damages flowing from the forged deed. Owed drafts the sworn affidavit; TRLA (above) handles the filing.",
        eligibility: ["Documentable financial loss caused by the decedent", "Filing within 4 years of decedent's death", "Claim with Aransas County probate (if an estate was opened) or alternate procedure if no probate was filed"],
        tags: ["reentry", "texas", "probate", "estate-claim", "local"],
        portal_url: "https://www.txcourts.gov/courts/probate-courts/",
        color: "accent",
    },
    {
        id: "g-tx-quiet-title",
        title: "Suit to Quiet Title — Invalidate Forged Deed",
        org: "Texas Property Code §22.001 · Aransas County District Court",
        orgShort: "QUIET TITLE",
        amount: 4000,
        deadline: "No statute of limitations on forged deed actions (Tex. Civ. Prac. & Rem. Code §16.028)",
        category: "reentry",
        difficulty: "Medium",
        matchScore: 90,
        description: "Formal court action to void a forged or fraudulent deed and restore clear title. Texas law is especially strong here — forgery does NOT pass title regardless of how long ago. Typical cost if privately retained: $3,000–$5,000. With TRLA attorney: $0. Owed drafts the supporting affidavit + evidence packet.",
        eligibility: ["You can document chain of title (probate paperwork from 2016)", "Documented evidence of forgery (bank records, forger's statements, etc.)", "TRLA or other attorney representing you"],
        tags: ["reentry", "texas", "legal", "title", "local"],
        portal_url: "https://www.trla.org/apply-for-help",
        color: "primary",
    },
    {
        id: "g-tx-wscb-tool-stipend",
        title: "Workforce Solutions Coastal Bend — Individual Training Account (Tool Stipend)",
        org: "Workforce Solutions of the Coastal Bend / WIOA",
        orgShort: "WSCB · ITA",
        amount: 2500,
        deadline: "Rolling",
        category: "reentry",
        difficulty: "Medium",
        matchScore: 94,
        description: "WIOA-funded Individual Training Account provides up to $2,500 for occupational supplies and tools — masonry trowels, welding helmet/jacket, carpentry kit, mechanic sockets, drywall gear, safety PPE. Paid directly to vendor so you walk out with the tools.",
        eligibility: ["Enrolled with Workforce Solutions Coastal Bend (same-day, free)", "Actively working in or training for an in-demand trade (masonry/welding/carpentry/mechanical/drywall all qualify)", "Low-income OR dislocated worker OR reentering workforce", "Texas resident"],
        tags: ["reentry", "texas", "tools", "trade", "local"],
        portal_url: "https://workforcesolutionscb.org/individuals/training-scholarships/",
        color: "primary",
    },
    {
        id: "g-tx-goodwill-career-tools",
        title: "Goodwill Career Services — Trade Tool Scholarship",
        org: "Goodwill Industries of South Texas · Career Services",
        orgShort: "GOODWILL",
        amount: 1200,
        deadline: "Rolling",
        category: "reentry",
        difficulty: "Easy",
        matchScore: 91,
        description: "Up to $1,200 vendor-direct for the specific tool kit your trade requires. Common packages: starter welder + hood + gloves; full drywall kit; masonry trowel set + level + mortar tools; carpentry hand-tool set; mechanic socket & wrench set. Stacks with WSCB ITA above.",
        eligibility: ["Job offer OR current employment in the trade", "Enrolled in Goodwill Career Services (same day)", "Household income under 200% federal poverty", "Texas resident"],
        tags: ["reentry", "texas", "tools", "trade", "local"],
        portal_url: "https://goodwillsouthtexas.com/programs/career-services/",
        color: "accent",
    },
    {
        id: "g-tx-property-tax-installments",
        title: "Aransas County Property Tax Installment Plan",
        org: "Aransas County Tax Assessor · TX Tax Code §31.031",
        orgShort: "ARANSAS CO",
        amount: 3500,
        deadline: "Rolling (apply before Feb 1 delinquency)",
        category: "reentry",
        difficulty: "Easy",
        matchScore: 96,
        description: "Texas law (§31.031) requires county tax offices to offer zero-interest quarterly installment plans to qualifying low-income homeowners. Split your annual property tax bill into 4 payments, no penalties, no collection action while enrolled.",
        eligibility: ["Own and occupy the property as your primary residence", "Apply before Feb 1 of the year taxes become delinquent", "Sign the §31.031 installment agreement at the tax office", "Not currently in delinquent collection proceedings"],
        tags: ["reentry", "texas", "property-tax", "state-only"],
        portal_url: "https://www.aransascountytx.gov/departments/tax-assessor-collector",
        color: "primary",
    },
    {
        id: "g-tx-property-tax-deferral",
        title: "Texas Property Tax Deferral (65+ / Disabled Homeowner) §33.06",
        org: "Texas Comptroller of Public Accounts",
        orgShort: "TX COMPT",
        amount: 8000,
        deadline: "Rolling",
        category: "reentry",
        difficulty: "Easy",
        matchScore: 92,
        description: "If you're 65+, receiving Social Security disability, or 100% VA-disabled, Texas Tax Code §33.06 lets you defer ALL property tax collection with only 5% simple interest. The tax office cannot foreclose while the deferral is active. Average deferred amount in TX: ~$8,000.",
        eligibility: ["Age 65+ OR qualifying disability (SSI/SSDI or 100% VA) OR surviving spouse of same", "Own and occupy the home", "File a sworn deferral affidavit with the county appraisal district", "Optional — Owed can pre-fill the affidavit for you"],
        tags: ["reentry", "texas", "property-tax", "state-only", "disabled", "senior", "conditional"],
        portal_url: "https://comptroller.texas.gov/taxes/property-tax/exemptions/",
        color: "accent",
    },
    {
        id: "g-tx-homestead-exemption",
        title: "Texas Homestead Exemption (Primary Residence Tax Cut)",
        org: "Aransas County Appraisal District",
        orgShort: "ACAD",
        amount: 2400,
        deadline: "April 30 (annual)",
        category: "reentry",
        difficulty: "Easy",
        matchScore: 94,
        description: "Removes $100,000 of your home's taxable value from school-district tax AND up to $40K more from county/city tax. For a typical Aransas Pass home, that's roughly $2,000–$3,000/year knocked off your property tax bill — permanently.",
        eligibility: ["Own the home as of January 1 of the tax year", "Live in the home as your primary residence", "State ID address matches the homestead address", "File Form 50-114 with Aransas County Appraisal District"],
        tags: ["reentry", "texas", "property-tax", "state-only"],
        portal_url: "https://www.aransascad.org/forms/",
        color: "primary",
    },
    {
        id: "g-tx-tdhca-hoaf",
        title: "TDHCA Homeowner Emergency Assistance Fund",
        org: "Texas Department of Housing & Community Affairs",
        orgShort: "TDHCA",
        amount: 25000,
        deadline: "Rolling (limited funds)",
        category: "reentry",
        difficulty: "Medium",
        matchScore: 89,
        description: "Texas homeowner emergency-rescue pool for past-due property tax, mortgage, insurance, and critical home repairs. Up to $25,000 per household — forgivable after 3 years of continued residency. Prioritizes disabled / senior / single-parent / reentry households.",
        eligibility: ["Income at or below 100% Area Median Income for Aransas County", "Property tax OR mortgage OR insurance delinquency OR urgent repair", "Owner-occupied primary residence", "Not in active foreclosure proceedings"],
        tags: ["reentry", "texas", "property-tax", "housing"],
        portal_url: "https://www.tdhca.texas.gov/texas-homeowner-assistance",
        color: "accent",
    },
    {
        id: "g-tx-goodwill-cars",
        title: "Goodwill Cars to Careers — Corpus Christi",
        org: "Goodwill Industries of South Texas",
        orgShort: "GOODWILL",
        amount: 6000,
        deadline: "Rolling",
        category: "reentry",
        difficulty: "Medium",
        matchScore: 95,
        description: "Refurbished, roadworthy vehicles gifted at zero or nominal cost to workforce-program participants who need reliable transport to work/training. Average vehicle value ~$6,000. You pay title/tags (~$200); Goodwill handles mechanical inspection + 30-day warranty.",
        eligibility: ["Enrolled in a Goodwill or Workforce Solutions employment program (Owed can enroll you)", "Valid Texas driver's license", "Show proof of employment or upcoming job start", "Auto insurance minimums ($30/$60/$25)", "Household income under 200% federal poverty line"],
        tags: ["reentry", "texas", "vehicle", "transportation"],
        portal_url: "https://goodwillsouthtexas.com/programs/cars-to-careers/",
        color: "primary",
    },
    {
        id: "g-tx-working-wheels",
        title: "Ways to Work Texas — 0%-Down Vehicle Loan",
        org: "Family Service Association / Ways to Work Texas",
        orgShort: "WAYS2WORK",
        amount: 8000,
        deadline: "Rolling",
        category: "reentry",
        difficulty: "Medium",
        matchScore: 88,
        description: "$6,000–$8,000 low-interest auto loan for people rebuilding credit after hardship — no credit score required, no down payment, fixed monthly payments tied to your income. Reports to credit bureaus so you build credit while you drive.",
        eligibility: ["Employment or firm job offer", "Valid Texas driver's license", "No active bankruptcy", "Household income below 80% Area Median"],
        tags: ["reentry", "texas", "vehicle", "transportation", "credit-building"],
        portal_url: "https://family-service.org/programs/ways-to-work/",
        color: "accent",
    },
    {
        id: "g-tx-workforce-transport",
        title: "Workforce Solutions Coastal Bend Transportation Voucher",
        org: "Workforce Solutions of the Coastal Bend",
        orgShort: "WSCB",
        amount: 2400,
        deadline: "Rolling",
        category: "reentry",
        difficulty: "Easy",
        matchScore: 93,
        description: "Weekly gas cards, bus passes, and rideshare vouchers while you're job-searching or in training. Up to $200/month for 12 months ($2,400 total). Combines with every other workforce program. Only 15 minutes from Aransas Pass.",
        eligibility: ["Registered with Workforce Solutions Coastal Bend (free, same-day)", "Actively job-searching, interviewing, or in a training program", "Coastal Bend resident"],
        tags: ["reentry", "texas", "transportation", "local"],
        portal_url: "https://workforcesolutionscb.org/",
        color: "primary",
    },
    {
        id: "g-tx-salvation-army-gear",
        title: "Salvation Army Corpus Christi — Work Clothing & Gear",
        org: "The Salvation Army of the Coastal Bend",
        orgShort: "SA CC",
        amount: 350,
        deadline: "Rolling",
        category: "reentry",
        difficulty: "Easy",
        matchScore: 86,
        description: "Work boots, kitchen whites/chef coats, interview outfit, hygiene kit, and a one-time grocery voucher — all free for people re-entering the workforce. Walk-in or call-ahead appointment at 520 Josephine St, Corpus Christi.",
        eligibility: ["Texas resident", "Show photo ID", "Brief needs assessment intake (15 min)", "One assistance package per 90 days"],
        tags: ["reentry", "texas", "clothing", "work-gear"],
        portal_url: "https://corpuschristi.salvationarmy.org/corpus_christi_tsa/",
        color: "accent",
    },
    {
        id: "g-second-chance-pell",
        title: "Second Chance Pell Grant — Postsecondary Education for Incarcerated & Recently Released",
        org: "U.S. Department of Education",
        orgShort: "ED",
        amount: 7395,
        deadline: "Rolling (per FAFSA cycle)",
        category: "reentry",
        difficulty: "Easy",
        matchScore: 94,
        description: "Federal Pell Grant is now fully available to individuals with past felony convictions after the FAFSA Simplification Act (2023). Need-based aid up to $7,395/year for undergrad — never repaid.",
        eligibility: ["Prior felony conviction allowed since 2023", "Enrolled or plan to enroll in approved program", "Valid FAFSA on file", "Demonstrated financial need", "US citizen or eligible non-citizen"],
        tags: ["reentry", "education", "FAFSA"],
        color: "primary",
    },
    {
        id: "g-federal-bonding",
        title: "Federal Bonding Program — Fidelity Bond for At-Risk Job Seekers",
        org: "U.S. Department of Labor",
        orgShort: "DOL",
        amount: 25000,
        deadline: "Rolling",
        category: "reentry",
        difficulty: "Easy",
        matchScore: 91,
        description: "Free $5,000–$25,000 fidelity bond covering the first 6 months of employment — removes the #1 barrier employers cite to hiring returning citizens. Applies to any job offer.",
        eligibility: ["Formerly incarcerated, on probation, or parole", "Have a job offer OR serious interview", "At-risk of being denied commercial bonding", "Any US state"],
        tags: ["reentry", "employment", "no-cost"],
        color: "accent",
    },
    {
        id: "g-second-chance-act",
        title: "Second Chance Act Reentry Grant",
        org: "DOJ Office of Justice Programs · Bureau of Justice Assistance",
        orgShort: "DOJ",
        amount: 50000,
        deadline: "2027-05-30",
        category: "reentry",
        difficulty: "Medium",
        matchScore: 88,
        description: "Federal funding for housing, employment training, mentoring, and substance-use services for people leaving state/federal prison. Individual-level support grants distributed via local reentry partners.",
        eligibility: ["Released within last 24 months", "Enrolled with a participating reentry provider", "Willing to complete case management plan"],
        tags: ["reentry", "housing", "employment"],
        color: "primary",
    },
    {
        id: "g-ceo-reentry",
        title: "CEO Transitional Employment Stipend",
        org: "Center for Employment Opportunities",
        orgShort: "CEO",
        amount: 3000,
        deadline: "Rolling",
        category: "reentry",
        difficulty: "Easy",
        matchScore: 87,
        description: "Same-day paid work for people with recent criminal convictions + stipends up to $3,000 for job retention milestones at 30/90/180/365 days. Operating in 30+ US cities.",
        eligibility: ["Felony conviction in the past 5 years", "In a CEO service area (30+ cities nationwide)", "Actively job-searching or newly employed", "Able to work legally"],
        tags: ["reentry", "cash-stipend", "employment"],
        color: "accent",
    },
    {
        id: "g-defy-ventures",
        title: "Defy Ventures — EIT Entrepreneurship Grant",
        org: "Defy Ventures (nonprofit)",
        orgShort: "DEFY",
        amount: 10000,
        deadline: "2027-04-15",
        category: "reentry",
        difficulty: "Medium",
        matchScore: 85,
        description: "Seed funding + year-long CEO-track business bootcamp for formerly incarcerated entrepreneurs. Graduates have launched 250+ businesses with an 82% job-placement rate.",
        eligibility: ["Prior felony conviction", "Business idea or early-stage venture", "Willing to complete the 12-month EIT program", "Any US state"],
        tags: ["reentry", "entrepreneurship", "minority-owned"],
        color: "primary",
    },
    {
        id: "g-hud-fairness",
        title: "HUD Fairness for Returning Citizens Housing Voucher",
        org: "U.S. Department of Housing & Urban Development",
        orgShort: "HUD",
        amount: 18000,
        deadline: "Rolling (via local PHA)",
        category: "reentry",
        difficulty: "Medium",
        matchScore: 83,
        description: "HUD policy updates (2023+) removed blanket bans on people with past convictions. Section 8 vouchers and public-housing access now use individualized review. Average voucher worth ~$18k/year.",
        eligibility: ["Released from incarceration", "Income at or below 50% AMI", "No active sex-offender registry requirement", "Apply through local Public Housing Authority"],
        tags: ["reentry", "housing", "section-8"],
        color: "accent",
    },
    {
        id: "g-sbir-phase1",
        title: "SBIR Phase I — Small Business Innovation",
        org: "National Science Foundation",
        orgShort: "NSF",
        amount: 275000,
        deadline: "2027-03-14",
        category: "business",
        difficulty: "Medium",
        matchScore: 92,
        description: "Non-dilutive funding for early-stage deep-tech startups to de-risk R&D. No equity taken.",
        eligibility: ["US-based for-profit", "Under 500 employees", "Majority US-owned", "Innovative tech or science angle"],
        tags: ["non-dilutive", "startup", "R&D"],
        color: "primary",
    },
    {
        id: "g-pell",
        title: "Federal Pell Grant",
        org: "U.S. Department of Education",
        orgShort: "ED",
        amount: 7395,
        deadline: "2026-09-30",
        category: "education",
        difficulty: "Easy",
        matchScore: 88,
        description: "Need-based aid for undergraduates pursuing a first bachelor's degree — does not need to be repaid.",
        eligibility: ["Undergraduate", "Demonstrated financial need", "US citizen or eligible non-citizen", "Valid FAFSA on file"],
        tags: ["need-based", "FAFSA", "undergrad"],
        color: "accent",
    },
    {
        id: "g-fha-downpayment",
        title: "First-Time Homebuyer Down Payment Assistance",
        org: "HUD / State Housing Finance Agency",
        orgShort: "HUD",
        amount: 15000,
        deadline: "Rolling",
        category: "housing",
        difficulty: "Easy",
        matchScore: 81,
        description: "Forgivable second-lien assistance for closing costs and down payment on your primary residence.",
        eligibility: ["First-time homebuyer", "Income at or below 120% AMI", "Primary residence", "Homebuyer education course"],
        tags: ["first-time buyer", "forgivable"],
        color: "terracotta",
    },
    {
        id: "g-usda-beginning-farmer",
        title: "USDA Beginning Farmer & Rancher Development",
        org: "USDA National Institute of Food and Agriculture",
        orgShort: "USDA",
        amount: 250000,
        deadline: "2027-04-12",
        category: "agriculture",
        difficulty: "Medium",
        matchScore: 74,
        description: "Project-based grants supporting education and mentorship for farmers in their first 10 years.",
        eligibility: ["Operating <10 years", "Educational or community component", "Collaborative project team"],
        tags: ["rural", "mentorship"],
        color: "primary",
    },
    {
        id: "g-nea-artworks",
        title: "NEA Grants for Arts Projects",
        org: "National Endowment for the Arts",
        orgShort: "NEA",
        amount: 50000,
        deadline: "2027-02-20",
        category: "arts",
        difficulty: "Medium",
        matchScore: 69,
        description: "Matching grants for exemplary projects across artistic disciplines that engage the public.",
        eligibility: ["501(c)(3) nonprofit or individual artist partner", "3-year operating history", "Matching funds 1:1"],
        tags: ["matching", "public engagement"],
        color: "accent",
    },
    {
        id: "g-va-vetrans-sba",
        title: "Boots to Business — Veteran Entrepreneurship",
        org: "Small Business Administration",
        orgShort: "SBA",
        amount: 10000,
        deadline: "Rolling",
        category: "veteran",
        difficulty: "Easy",
        matchScore: 95,
        description: "Entrepreneurship training and seed capital for transitioning service members and military spouses.",
        eligibility: ["Veteran or military spouse", "DD-214 or equivalent", "Completed Boots to Business course"],
        tags: ["veteran", "seed"],
        color: "primary",
    },
    {
        id: "g-nih-r21",
        title: "NIH R21 Exploratory Research Grant",
        org: "National Institutes of Health",
        orgShort: "NIH",
        amount: 275000,
        deadline: "2027-05-07",
        category: "research",
        difficulty: "Hard",
        matchScore: 61,
        description: "Support novel, exploratory high-risk/high-reward biomedical research projects up to 2 years.",
        eligibility: ["Affiliated with research institution", "PhD or equivalent", "Preliminary data not required"],
        tags: ["biomedical", "exploratory"],
        color: "terracotta",
    },
    {
        id: "g-community-cdbg",
        title: "Community Development Block Grant (CDBG)",
        org: "HUD",
        orgShort: "HUD",
        amount: 500000,
        deadline: "2027-07-15",
        category: "community",
        difficulty: "Medium",
        matchScore: 78,
        description: "Flexible community revitalization funding for housing, public services, and economic development.",
        eligibility: ["Local government or qualifying nonprofit", "Serves low-to-moderate income population", "Consolidated Plan alignment"],
        tags: ["community", "flexible use"],
        color: "primary",
    },
    {
        id: "g-women-amber",
        title: "Amber Grant for Women",
        org: "WomensNet",
        orgShort: "WNET",
        amount: 10000,
        deadline: "Monthly",
        category: "business",
        difficulty: "Easy",
        matchScore: 84,
        description: "Monthly $10K award plus year-end $25K for women-owned businesses — short application.",
        eligibility: ["Women-owned (50%+) business", "US or Canada", "Operating or pre-revenue OK"],
        tags: ["women-owned", "monthly"],
        color: "accent",
    },
    {
        id: "g-energy-heat-pump",
        title: "Residential Heat Pump & Efficiency Rebate (IRA)",
        org: "Department of Energy",
        orgShort: "DOE",
        amount: 8000,
        deadline: "Rolling",
        category: "housing",
        difficulty: "Easy",
        matchScore: 72,
        description: "Inflation Reduction Act rebate stacking for heat pumps, insulation, and electrical upgrades.",
        eligibility: ["Primary residence", "Household income under 150% AMI", "Qualified contractor install"],
        tags: ["rebate", "IRA", "energy"],
        color: "primary",
    },
    {
        id: "g-mrfr-minority",
        title: "MBDA Capital Readiness Program",
        org: "Minority Business Development Agency",
        orgShort: "MBDA",
        amount: 125000,
        deadline: "2027-04-01",
        category: "business",
        difficulty: "Medium",
        matchScore: 77,
        description: "Technical assistance and capital access for underrepresented entrepreneurs scaling existing ventures.",
        eligibility: ["Minority-owned", "In operation 2+ years", "Seeking growth capital"],
        tags: ["minority-owned", "scale"],
        color: "terracotta",
    },
    {
        id: "g-childcare-startup",
        title: "Child Care Stabilization Grant",
        org: "Administration for Children & Families",
        orgShort: "ACF",
        amount: 35000,
        deadline: "2027-03-30",
        category: "community",
        difficulty: "Easy",
        matchScore: 65,
        description: "Operational support for licensed child care providers — personnel, supplies, and facility costs.",
        eligibility: ["Licensed provider", "Open & operating", "Accepting subsidies a plus"],
        tags: ["childcare", "operations"],
        color: "accent",
    },
];

// Public-safe sample for unauthenticated showcase surfaces (landing "Live sample"
// + /demo). Must NEVER include entries tailored to a specific user / case.
const PUBLIC_SAMPLE_IDS = new Set(["g-women-amber", "g-pell", "g-sbir-phase1"]);
export const PUBLIC_SAMPLE_GRANTS = GRANTS.filter((g) => PUBLIC_SAMPLE_IDS.has(g.id));

export const UNCLAIMED = [
    {
        id: "u-dormant-chase",
        type: "unclaimed_property",
        source: "NY State Comptroller — Office of Unclaimed Funds",
        amount: 1247.83,
        description: "Dormant checking account balance from Chase branch closure (2019).",
        confidence: 91,
        action: "Submit Form AC-3198 with ID & proof of address",
    },
    {
        id: "u-insurance-refund",
        type: "unclaimed_property",
        source: "State of California — Unclaimed Property Division",
        amount: 384.12,
        description: "Unreturned insurance premium refund from 2021 auto policy.",
        confidence: 86,
        action: "File UPS-3 claim with supporting policy docs",
    },
    {
        id: "u-utility-deposit",
        type: "unclaimed_property",
        source: "Texas Comptroller of Public Accounts",
        amount: 185.0,
        description: "Unreturned utility security deposit from a prior residence.",
        confidence: 78,
        action: "Online claim via ClaimItTexas.org",
    },
    {
        id: "u-undeliv-refund",
        type: "tax_refund",
        source: "Internal Revenue Service",
        amount: 892.0,
        description: "Undelivered federal tax refund from a prior address change.",
        confidence: 94,
        action: "Update address via USPS + IRS Form 8822",
    },
    {
        id: "u-savings-bond",
        type: "savings_bond",
        source: "TreasuryDirect — Treasury Hunt",
        amount: 625.0,
        description: "Matured Series EE savings bond issued to you in 1998, never redeemed.",
        confidence: 88,
        action: "Submit FS Form 1048 with identity docs",
    },
    {
        id: "u-pension",
        type: "pension",
        source: "Pension Benefit Guaranty Corporation",
        amount: 4200.0,
        description: "Unclaimed pension from terminated employer plan (Meridian Corp).",
        confidence: 72,
        action: "Search pbgc.gov/search-unclaimed and file claim",
    },
    {
        id: "u-401k-rollover",
        type: "retirement",
        source: "National Registry of Unclaimed Retirement Benefits",
        amount: 7840.0,
        description: "Orphaned 401(k) balance from a former employer.",
        confidence: 69,
        action: "Contact plan administrator, rollover to IRA",
    },
    {
        id: "u-escrow",
        type: "unclaimed_property",
        source: "Florida Department of Financial Services",
        amount: 540.23,
        description: "Residual escrow from a closed mortgage account.",
        confidence: 83,
        action: "Submit claim via FLTreasureHunt.gov",
    },
];

export const TAX_CREDITS = [
    {
        id: "t-eitc",
        name: "Earned Income Tax Credit (EITC)",
        agency: "IRS",
        estimate: 3400,
        years: [2023, 2022, 2021],
        description: "Refundable credit for low-to-moderate income workers — ~20% of eligible filers miss it.",
        action: "File Form 1040 with Schedule EIC (retroactive up to 3 years).",
    },
    {
        id: "t-saver",
        name: "Saver's Credit",
        agency: "IRS",
        estimate: 1000,
        years: [2024, 2023],
        description: "Credit for retirement account contributions if AGI is under threshold.",
        action: "Complete Form 8880 when filing.",
    },
    {
        id: "t-aotc",
        name: "American Opportunity Credit",
        agency: "IRS",
        estimate: 2500,
        years: [2024, 2023, 2022],
        description: "Up to $2,500 per student for qualified education expenses during first 4 years.",
        action: "Form 8863 — requires 1098-T from school.",
    },
    {
        id: "t-energy",
        name: "Residential Clean Energy Credit",
        agency: "IRS",
        estimate: 1800,
        years: [2024, 2023],
        description: "30% back on solar, battery, geothermal and related installs.",
        action: "Form 5695 with your installer's certification.",
    },
];

export const SETTLEMENTS = [
    {
        id: "s-equifax",
        name: "Equifax Data Breach Settlement",
        estimate: 125,
        deadline: "2027-01-22",
        status: "Open",
        description: "Eligible if your data was exposed in the 2017 breach. Cash or free credit monitoring.",
        action: "Submit claim on equifaxbreachsettlement.com",
    },
    {
        id: "s-tmobile",
        name: "T-Mobile 2021 Data Breach",
        estimate: 60,
        deadline: "2027-02-14",
        status: "Open",
        description: "Former/current customers between 2019-2022 may qualify for out-of-pocket or lump sum.",
        action: "File through tmobilesettlement.com",
    },
    {
        id: "s-google-plus",
        name: "Google Location History Settlement",
        estimate: 30,
        deadline: "2027-03-10",
        status: "Open",
        description: "Class members with Google accounts active in 2014-2020 eligible for flat payment.",
        action: "Submit claim with Google account email.",
    },
    {
        id: "s-robinhood",
        name: "Robinhood Outage Settlement",
        estimate: 72,
        deadline: "2027-04-01",
        status: "Open",
        description: "Users who experienced trading outages during March 2020 market volatility.",
        action: "Auto-enrolled if eligible — confirm address on file.",
    },
    {
        id: "s-facebook",
        name: "Meta Cambridge Analytica Settlement",
        estimate: 45,
        deadline: "Closed",
        status: "Claimed",
        description: "Facebook users in US between 2007-2022 — disbursement pending.",
        action: "No action needed — payment in queue.",
    },
];

export const TESTIMONIALS = [
    {
        quote: "I found $1,247 in an old checking account I'd completely forgotten about. Claim filed in under 10 minutes.",
        name: "Marcus T.",
        role: "Software engineer, Brooklyn",
        amount: "$1,247",
    },
    {
        quote: "Owed matched me with the Amber Grant and walked me through every answer. Won $10,000 for my bakery.",
        name: "Priya R.",
        role: "Founder, Flour & Honey",
        amount: "$10,000",
    },
    {
        quote: "Missed the EITC for three years — they pulled it together with one checklist. Got $8,400 back.",
        name: "Denise W.",
        role: "Teacher, Phoenix",
        amount: "$8,400",
    },
    {
        quote: "The veteran grant finder is worth the app alone. Boots to Business funding + mentoring in six weeks.",
        name: "Jamal O.",
        role: "USMC veteran, Atlanta",
        amount: "$10,000",
    },
];

export const STATS = [
    { value: "$73B", label: "Unclaimed at state treasurers" },
    { value: "1 in 7", label: "Americans owed money today" },
    { value: "$1,200", label: "Average claim we surface" },
    { value: "47 min", label: "Median application time" },
];

export const FAQ_ITEMS = [
    {
        q: "Is this actually free?",
        a: "The core finder, eligibility checks, and claim walkthroughs are free. We earn revenue from optional premium review and white-glove application help — never from your recovered funds.",
    },
    {
        q: "How do you know what I'm eligible for?",
        a: "We match your profile (income, household, state, status, interests) against 1,400+ federal and state programs, public unclaimed-property databases, active class-action settlements, and missed tax credits from prior filing years.",
    },
    {
        q: "Do you submit paperwork on my behalf?",
        a: "We prepare and organize every form. For most claims you sign and submit directly to the issuing agency — that keeps you in control and avoids power-of-attorney requirements. Premium adds e-file assistance where available.",
    },
    {
        q: "What about that 'trust fund at birth with my SSN'?",
        a: "That's a debunked theory (commonly called 'strawman' or 'redemption'). There is no Treasury trust tied to your SSN. Filing redemption paperwork leads to IRS fraud penalties. Instead, we help you recover the real money you're actually owed — unclaimed property, missed tax credits, settlements, and grants.",
    },
    {
        q: "How do you keep my data safe?",
        a: "Bank-grade AES-256 at rest, TLS 1.3 in transit, SOC 2 Type II in progress. We never sell personal data and you can delete your account and all records at any time.",
    },
    {
        q: "What if I'm not eligible for anything?",
        a: "Most users are eligible for at least one program. If you're not, we'll tell you plainly and point you to adjacent resources — no upsell, no guilt.",
    },
];

export const formatMoney = (n, opts = {}) => {
    const { compact = false } = opts;
    if (compact && n >= 1000) {
        return "$" + (n / 1000).toFixed(n >= 10000 ? 0 : 1) + "k";
    }
    return n.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: n % 1 === 0 ? 0 : 2,
    });
};

export const formatDeadline = (d) => {
    if (!d || d === "Rolling" || d === "Monthly" || d === "Closed") return d;
    try {
        const date = new Date(d);
        return date.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
    } catch {
        return d;
    }
};

export const daysUntil = (d) => {
    if (!d || ["Rolling", "Monthly", "Closed"].includes(d)) return null;
    const diff = (new Date(d) - new Date()) / (1000 * 60 * 60 * 24);
    return Math.max(0, Math.round(diff));
};
